<template>
  <div class="box12">
    <div class="content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <img
            :src="
              require(`../../../assets/coursePage/architect/box11/${
                index + 1
              }.jpg`)
            "
            alt
          />
        </swiper-slide>
      </swiper>
    </div>
    <div class="tip">
      * 为了避免对学员造成影响，以上数据做了部分隐藏处理
      <br />相关数据来源于公司内部真实统计
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      list: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 20,
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box12",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box12 {
  padding-bottom: 88px;
  width: 100%;
  background: #f5f9ff;

  .content {
    position: relative;
   

    img {
      padding: 4px;
      width: 411px;
      height: 728px;
      background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
    }
  }
  .tip {
    margin-top: 30px;
    text-align: center;
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 0px;
    color: #24375c;
  }

  .swiper-slide {
    display: flex;
    align-items: center;
    padding: 4px;
    width: 411px;
    height: 728px;
    background: #f5f9ff;
    border-radius: 20px;
    box-sizing: border-box;
    img {
      padding: 4px;
      width: 406px;
      height: 662px;
      background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
      transition: all 0.3s;
    }
  }
  .swiper-slide-active {
    img {
      width: 450px;
      height: 736px;
      border-radius: 24px;
      margin-left: -7px;
    }
  }
  .swiper-pagination-box12 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    margin-top: 32px;
    background-color: #b6ddff;
    transform: translate(-50%, 0px);
    border-radius: 3px;
    // width: 60px;
    // height: 6px;

    // // background: #70c3f7;
    // background: rgba(46, 165, 252, 0.16);
    // border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 10px;
    height: 6px;
    background-color: #b6ddff;
    border-radius: 3px;
    opacity: 1;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background-color: #57a3f5;
    border-radius: 3px;
  }
}
</style>
